import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable, timeout, catchError, throwError } from 'rxjs';
import { AuthInterceptorHelper } from 'src/app/services/auth-interceptor-helper/auth-interceptor-helper';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { SKIP_LOADER } from './http-context-tokens';
import { environment } from 'src/environments/environment'
import { Router } from '@angular/router';
import { ErrorPageType } from 'src/app/helpers/enum/error-page-type.enum';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private readonly skipTimeoutUrls: string[] = [
    'auth/jwt/refresh'
  ];

  private readonly refreshAPIUrls: string[] = [
    'api/v1/me',
    'api/v1/NotUsingMyVehicle/GetNotUsingMyVehicle'
  ];

  constructor(
    private readonly authInterceptorHelper: AuthInterceptorHelper,
    private readonly loaderService: LoaderService,
    private readonly router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const modifiedReq = this.authInterceptorHelper.handleHttpHeaders(req);

    if (!req.context.get(SKIP_LOADER)) {
      this.loaderService.showLoader();
    }

    let request$ = next.handle(modifiedReq);

    const shouldSkipTimeout = this.skipTimeoutUrls.some(url =>
      req.url.includes(url)
    );

    // Apply timeout only if not in skip list
    if (!shouldSkipTimeout) {
      request$ = request$.pipe(
        timeout(environment.httpTimeOut * 1000)
      );
    }


    return request$.pipe(
      catchError((error) => {
        error.message = `${error.message} | API: ${req.url}`;

        if (error.name === 'TimeoutError' && !shouldSkipTimeout) {
          const isMeDataApi = req.url.includes('api/v1/me');
          const isNotUsingMyVehicleApi = req.url.includes(
            'api/v1/NotUsingMyVehicle/GetNotUsingMyVehicle'
          );

          let errorType = ErrorPageType.TIMEOUT_ERROR;
          let api: string | null = null;

          if (isMeDataApi) {
            errorType = ErrorPageType.TIMEOUT_ERROR_REFRESH;
            api = 'MeData';
          } else if (isNotUsingMyVehicleApi) {
            errorType = ErrorPageType.TIMEOUT_ERROR_REFRESH;
            api = 'GetNotUsingMyVehicle';
          }

          const queryParams: { type: ErrorPageType; api?: string } = {
            type: errorType
          };

          if (api) {
            queryParams.api = api;
          }

          this.router.navigate(['/error'], { queryParams });

          return throwError(() => error);
        }



        return throwError(() => error);
      }),
      finalize(() => {
        if (!req.context.get(SKIP_LOADER)) {
          this.loaderService.hideLoader();
        }
      })
    );
  }

}